import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Button,
    DialogActions,
    CircularProgress,
} from "@mui/material";

const GeneralModalV1 = ({
    title,
    subtitle,
    children,
    isOpen,
    handleClose,
    handleConfirm,
    hideCancelButton,
    confirmMessage,
    cancelMessage,
    confirmLoader,
}: any) => {
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        setLoader(confirmLoader);
    }, [confirmLoader]);
    return (
        <Dialog fullWidth maxWidth={"xs"} open={isOpen} onClose={handleClose}>
            <div className="m-2">
                <div className="dialog-title-custom d-flex j-center">
                    <h3>{title}</h3>
                </div>
                <div className="dialog-content-custom">
                    <span className="w-80">{children}</span>
                </div>
            </div>
            <div className="d-flex j-center mb-2">
                {!hideCancelButton && (
                    <Button
                        onClick={handleClose}
                        color="error"
                        variant="contained"
                    >
                        {cancelMessage || "Cancel"}
                    </Button>
                )}

                <Button
                    startIcon={
                        loader ? (
                            <CircularProgress color="inherit" size={20} />
                        ) : null
                    }
                    className="ml-1"
                    onClick={handleConfirm}
                    color="primary"
                    variant="contained"
                >
                    {confirmMessage || "Confirm"}
                </Button>
            </div>
        </Dialog>
    );
};

export default GeneralModalV1;
